/* ==========================================================================
   Casemira - la 2e photo de carte, chargée seulement quand on la demande
                                                          C3, vague 3, 2026
   --------------------------------------------------------------------------
   POURQUOI CE FICHIER EXISTE

   Le thème rend la 2e photo de chaque carte dans le HTML, en `loading="lazy"`.
   « Lazy » ne veut pas dire « jamais » : dès que la carte entre dans la fenêtre,
   le navigateur la télécharge. Sur une grille de 36 tapis, cela fait 36 photos
   téléchargées que personne n'a demandées - c'est nommément l'erreur la plus
   coûteuse des thèmes Shopify à survol dans `benchmark/BONNES-PRATIQUES.md` § 8,
   et la règle 9 du même document (« une seule image chargée par carte, la
   seconde uniquement à l'intention de survol »).

   `card-product.liquid` ne rend donc, sur la grille de collection, qu'une boîte
   VIDE au bon ratio, porteuse des attributs `data-cm-*`. Ce fichier y pose une
   balise `<img>` au moment où la 2e photo devient utile :

     · ordinateur (pointeur fin) : à l'entrée du pointeur sur la carte. Le fondu
       dure 420 ms, la photo arrive pendant ;
     · tactile : au premier contact sur la photo, c'est-à-dire à l'amorce du
       glissement. Le carrousel de `casemira-card-swipe.js` met 350 ms à faire
       défiler, la photo arrive pendant. La boîte porte un fond sable en
       attendant, donc rien ne saute.

   CE QUE CE FICHIER NE FAIT PAS
   Le bandeau de formats au survol est du CSS pur (`casemira-card.css`) et ses
   liens sont de vrais `<a href>` rendus par Liquid : rien ici ne les touche, et
   ils fonctionnent sans JavaScript.

   RENDU AJAX
   `facets.js` remplace la grille entière à chaque filtre. Un script réinséré par
   `innerHTML` ne s'exécute pas : tous les écouteurs sont donc DÉLÉGUÉS au
   document et posés une seule fois. Aucun recâblage n'est nécessaire après un
   filtrage, aucune observation de mutations non plus.
   ========================================================================== */

(function () {
  'use strict';

  /* Le fichier est chargé une fois par page, mais la carte le déclare sur
     chacune de ses instances par sécurité (voir card-product.liquid) : ce
     garde-fou rend une double exécution inoffensive. */
  if (window.__cmCardInit) return;
  window.__cmCardInit = true;

  var SEL = '[data-cm-second]';

  /* ------------------------------------------------------------------------
     Pose la balise <img> dans la boîte, une seule fois par carte.
     `decoding="async"` : le décodage ne bloque pas le fil principal pendant que
     l'utilisateur continue de faire défiler.
     `loading="lazy"` reste posé : si la carte est déjà sortie de l'écran au
     moment où la photo arrive, le navigateur peut encore l'abandonner.
  ------------------------------------------------------------------------ */
  function fill(box) {
    if (!box || box.dataset.cmFilled === '1') return;
    var src = box.getAttribute('data-cm-src');
    if (!src) {
      box.dataset.cmFilled = '1';
      return;
    }
    box.dataset.cmFilled = '1';

    var img = document.createElement('img');
    img.className = 'motion-reduce';
    img.loading = 'lazy';
    img.decoding = 'async';
    img.alt = box.getAttribute('data-cm-alt') || '';
    var w = box.getAttribute('data-cm-w');
    var h = box.getAttribute('data-cm-h');
    if (w) img.setAttribute('width', w);
    if (h) img.setAttribute('height', h);
    var srcset = box.getAttribute('data-cm-srcset');
    var sizes = box.getAttribute('data-cm-sizes');
    if (srcset) img.srcset = srcset;
    if (sizes) img.sizes = sizes;
    img.src = src;

    /* Deux classes à l'arrivée de la photo :
         · `loaded` est celle du thème, elle retire le fond de remplissage du
           conteneur média ;
         · `cm-second-ready`, posée sur le CADRE, autorise le CSS à effacer la
           1re photo. Sans elle, le survol ferait disparaître la photo
           d'ambiance avant que la vue à plat ne soit arrivée : la carte
           montrerait un rectangle sable pendant le téléchargement. Le fondu
           n'a lieu que quand il y a quelque chose à révéler. */
    img.addEventListener(
      'load',
      function () {
        box.classList.add('loaded');
        var frame = box.closest('.product-card__image-wrapper');
        if (frame) frame.classList.add('cm-second-ready');
      },
      { once: true }
    );

    box.appendChild(img);
  }

  /* Remonte de la cible de l'événement jusqu'à la carte, puis descend sur la
     boîte de 2e photo. `closest` s'arrête à la carte : viser directement la
     boîte ne marcherait pas, le pointeur est sur la 1re photo, pas sur elle. */
  function fillFrom(target) {
    if (!target || !target.closest) return;
    var card = target.closest('.cm-card');
    if (!card) return;
    var box = card.querySelector(SEL);
    if (box) fill(box);
  }

  /* ------------------------------------------------------------------------
     Ordinateur : intention de survol.
     `pointerover` plutôt que `mouseenter` : un seul écouteur délégué suffit,
     là où `mouseenter` ne remonte pas et demanderait un écouteur par carte.
     Le filtre `pointerType === 'mouse'` évite de déclencher deux fois sur les
     appareils hybrides, où le contact tactile est traité plus bas.
  ------------------------------------------------------------------------ */
  document.addEventListener(
    'pointerover',
    function (e) {
      if (e.pointerType && e.pointerType !== 'mouse') return;
      fillFrom(e.target);
    },
    { passive: true, capture: true }
  );

  /* Clavier : `focus` traverse en capture (il ne bulle pas). Le bandeau de
     formats s'ouvre en `:focus-within`, la photo doit suivre. */
  document.addEventListener(
    'focusin',
    function (e) {
      fillFrom(e.target);
    },
    { passive: true }
  );

  /* ------------------------------------------------------------------------
     Tactile : intention de glissement.
     Le contact sur la photo précède le glissement de `casemira-card-swipe.js`.
     On ne déclenche que si le contact a lieu DANS le cadre photo, pour ne pas
     charger une photo à chaque effleurement du titre pendant un défilement.
  ------------------------------------------------------------------------ */
  document.addEventListener(
    'touchstart',
    function (e) {
      var t = e.target;
      if (!t || !t.closest) return;
      if (!t.closest('.product-card__image-wrapper')) return;
      fillFrom(t);
    },
    { passive: true }
  );
})();
